/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FormTemplate } from '../models/FormTemplate';
import type { FormTemplateUpload } from '../models/FormTemplateUpload';
import type { SessionFormat } from '../models/SessionFormat';
import type { SessionFormatCreateRequest } from '../models/SessionFormatCreateRequest';
import type { SessionFormatReorder } from '../models/SessionFormatReorder';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SessionFormatsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns SessionFormat
     * @throws ApiError
     */
    public sessionFormatList(): CancelablePromise<Array<SessionFormat>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/session-formats/',
        });
    }
    /**
     * @returns SessionFormat
     * @throws ApiError
     */
    public sessionFormatCreate({
        requestBody,
    }: {
        requestBody: SessionFormatCreateRequest,
    }): CancelablePromise<SessionFormat> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/session-formats/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns SessionFormat
     * @throws ApiError
     */
    public sessionFormatUpdate({
        sessionFormatId,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this session format.
         */
        sessionFormatId: number,
        requestBody: SessionFormatCreateRequest,
    }): CancelablePromise<SessionFormat> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/session-formats/{session_format_id}/',
            path: {
                'session_format_id': sessionFormatId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public sessionFormatDelete({
        sessionFormatId,
        force,
    }: {
        /**
         * A unique integer value identifying this session format.
         */
        sessionFormatId: number,
        /**
         * Force delete and set format_id to None for all sessions with this format_id.
         */
        force?: boolean,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/session-formats/{session_format_id}/',
            path: {
                'session_format_id': sessionFormatId,
            },
            query: {
                'force': force,
            },
        });
    }
    /**
     * @returns FormTemplate
     * @throws ApiError
     */
    public sessionFormatFormTemplateCreate({
        sessionFormatId,
        requestBody,
    }: {
        sessionFormatId: number,
        requestBody: FormTemplateUpload,
    }): CancelablePromise<FormTemplate> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/session-formats/{session_format_id}/form-template/',
            path: {
                'session_format_id': sessionFormatId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns FormTemplate
     * @throws ApiError
     */
    public sessionFormatFormTemplateRetrieve({
        id,
        sessionFormatId,
    }: {
        id: number,
        sessionFormatId: number,
    }): CancelablePromise<FormTemplate> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/session-formats/{session_format_id}/form-template/{id}/',
            path: {
                'id': id,
                'session_format_id': sessionFormatId,
            },
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public sessionFormatFormTemplateDestroy({
        id,
        sessionFormatId,
    }: {
        id: number,
        sessionFormatId: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/session-formats/{session_format_id}/form-template/{id}/',
            path: {
                'id': id,
                'session_format_id': sessionFormatId,
            },
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public sessionFormatSetDefault({
        sessionFormatId,
    }: {
        /**
         * A unique integer value identifying this session format.
         */
        sessionFormatId: number,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/session-formats/{session_format_id}/set-default/',
            path: {
                'session_format_id': sessionFormatId,
            },
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public sessionFormatReorder({
        requestBody,
    }: {
        requestBody: SessionFormatReorder,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/session-formats/reorder/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    public sessionFormatUnsetDefault(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/session-formats/unset-default/',
        });
    }
}
